import React, { useState } from "react";
import { useCheckout } from "@/api/hooks";
import { ShoppingCart, Loader2 } from "lucide-react";

export default function FvtCheckoutButton({ color = "#c8f135" }) {
  const [error, setError] = useState(null);
  const checkout = useCheckout();

  const handleCheckout = async () => {
    setError(null);
    try {
      const res = await checkout.mutateAsync();
      if (res?.url) {
        window.location.href = res.url;
      } else {
        setError(res?.error || "שגיאה בפתיחת תשלום");
      }
    } catch (err) {
      setError(err.message || "שגיאה בפתיחת תשלום");
    }
  };

  return (
    <div>
      <button
        onClick={handleCheckout}
        disabled={checkout.isPending}
        className="w-full py-4 rounded-xl font-black text-base transition-all disabled:opacity-60 flex items-center justify-center gap-2"
        style={{ background: color, color: "#000" }}
      >
        {checkout.isPending ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <>
            <ShoppingCart className="w-5 h-5" />
            רכוש FVT — $199
          </>
        )}
      </button>
      {error && (
        <p className="text-xs mt-2 text-center" style={{ color: "#ef4444" }}>{error}</p>
      )}
    </div>
  );
}
